import { useTranslate } from '../../application/i18n/LocaleProvider';

/**
 * Who are you playing (SPEC-011 D-28).
 *
 * ONE QUESTION, TWO ANSWERS — the app, or somebody else. It asked two more
 * before this: which opponent skill, and which of three rules decides who names
 * the figure next round. Both were real questions and both are gone, because
 * asking them here was the wrong place to be right. A reader arriving at a card
 * game they have never played is not equipped to choose between "the winner"
 * and "in turn"; the choice they can make is the one everybody makes when they
 * pick up a pack of cards, which is WHO they are playing. Three questions to
 * get to a deal also made the shortest path into the game four taps long, and
 * the second and third of them were answered with their defaults by everybody
 * who did not already know the rules.
 *
 * SO THE DEFAULTS BECAME THE GAME. `pro` and `winner` were the settings this
 * screen opened on, and they are the ones the game is designed around: an
 * opponent that spends the cheapest card that wins is the one worth beating,
 * and winner-leads is what makes a run a run — take a pot and you choose the
 * next figure. `MATCH_RULES` is exported so a test can pin exactly that, since
 * a rule nobody can see on screen is a rule that could otherwise drift with no
 * failure anywhere.
 *
 * They are still SETTINGS in `domain/game` rather than constants — `LEAD_RULES`
 * and `OPPONENT_SKILLS` are unchanged, the invited match deals under
 * `alternate`, and the rules engine goes on taking all three of each. What went
 * is the question, not the capability.
 *
 * The other answer is `OvertakeInvite`, drawn beside this one by the screen: it
 * owns the account, the link and the four ways opening one can fail, which is
 * far more than a second button in here could carry.
 */

/**
 * What a local match is dealt under, now that nobody is asked.
 *
 * Exported for the test that pins it. A default that lives only in a call
 * argument is a default that changes silently.
 */
export const MATCH_RULES = { skill: 'pro', leadRule: 'winner' };

export default function OvertakeSetup({ onDeal }) {
    const t = useTranslate();

    return (
        <section className="overtake-setup">
            <h2 className="overtake-setup__title">{t('play.setup.title')}</h2>
            <p className="overtake-setup__intro">{t('play.setup.intro')}</p>

            {/* The first of the two answers. The second is the invite plate
                below it, drawn to the same shape by the same sheet — they are
                one question, so they may not look like two different kinds of
                thing. */}
            <div className="overtake-setup__option">
                <h3 className="overtake-setup__name">{t('play.setup.app')}</h3>
                <p className="overtake-setup__note">{t('play.setup.app.note')}</p>

                <button
                    type="button"
                    className="button button--primary overtake-setup__deal"
                    onClick={() => onDeal(MATCH_RULES)}
                >
                    {t('play.setup.deal')}
                </button>
            </div>
        </section>
    );
}
